// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"1546db51","419":"b3868116","520":"2d4cd0aa","576":"1546db51","729":"837b32ab","896":"d75c5eed"}[chunkId] + ".chunk.css";
};